module.exports = __webpack_public_path__ + "static/media/rails.e4b772f4.png";